import { alpha, Chip, ChipProps } from '@mui/material';

export const OfferingFilterChip = ({ sx, ...rest }: ChipProps) => {
  return (
    <Chip
      variant="outlined"
      sx={{
        lineHeight: ({ lineHeights }) => lineHeights['2xs'],
        color: 'font.600',
        textTransform: 'none',
        '&.MuiChip-root.MuiChip-clickable': {
          '&.active': {
            backgroundColor: 'secondary.main',
            borderColor: 'secondary.main',
            color: 'white',
          },
        },
        '@media (hover: hover)': {
          '&.MuiChip-root.MuiChip-clickable:hover': {
            backgroundColor: ({ palette }) => alpha(palette.secondary.main, 0.7),
            borderColor: ({ palette }) => alpha(palette.secondary.main, 0.7),
            color: 'white',
          },
        },
        ...sx,
      }}
      {...rest}
    />
  );
};
